var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatText = function SvgChatText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18c0-.69.56-1.25 1.25-1.25h8a1.25 1.25 0 1 1 0 2.5h-8c-.69 0-1.25-.56-1.25-1.25",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25v19.066l3.694-3.105c.111-.094.239-.167.376-.217l.46-.168a1.3 1.3 0 0 1 .429-.076H26.75V8.25zM3.409 6.41A2.25 2.25 0 0 1 5 5.75h22A2.25 2.25 0 0 1 29.25 8v16A2.25 2.25 0 0 1 27 26.25H10.43l-.046.017-3.936 3.308a2.25 2.25 0 0 1-3.698-1.722V8c0-.597.237-1.169.659-1.59",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14c0-.69.56-1.25 1.25-1.25h8a1.25 1.25 0 1 1 0 2.5h-8c-.69 0-1.25-.56-1.25-1.25",
    clipRule: "evenodd"
  })));
};
export default SvgChatText;